<script setup lang="ts">
import { FilterType } from '~/lib/interfaces/restaurant'

const { isFilterSelected = false, filterText } = defineProps<{
  isFilterSelected: boolean
  filterText: FilterType
}>()

const { t } = useLocale()
</script>

<template>
  <div
    class="flex w-fit cursor-pointer flex-row gap-1 rounded-2xl border border-mcd-black px-4 py-2"
    :class="isFilterSelected ? 'bg-mcd-main' : 'bg-mcd-secondary'"
    :data-test="`restaurant-filter-${filterText}`"
  >
    <img
      :src="`/images/icons/restaurantFilters/${filterText}.svg`"
      class="h-4 w-4"
      :alt="filterText"
    />
    <p class="whitespace-nowrap text-xs font-bold leading-4">
      {{ t(`selectRestaurant.filters.${filterText}`) }}
    </p>
  </div>
</template>
